import React from 'react';
import './PoliciesSection.css';

const policies = [
  {
    icon: '👨‍👩‍👧',
    title: 'Supervision',
    text: 'All children must be accompanied by an adult at all times.',
  },
  {
    icon: '📅',
    title: 'Reservations',
    text: 'Free cancellation up to 24 hours in advance.',
  },
  {
    icon: '🚭',
    title: 'Smoke-Free',
    text: 'This is a completely smoke-free environment.',
  },
  {
    icon: '🐕',
    title: 'Pets',
    text: 'Service animals welcome. Other pets not permitted.',
  },
];

const PoliciesSection = () => (
  <div className="policies-section">
    <h2 className="policies-title">Things to know</h2>
    <div className="policies-grid">
      {policies.map((policy, idx) => (
        <div key={idx} className="policy-card">
          <span className="policy-icon">{policy.icon}</span>
          <div className="policy-content">
            <span className="policy-name">{policy.title}</span>
            <span className="policy-text">{policy.text}</span>
          </div>
        </div>
      ))}
    </div>
    <a href="#" className="report-link">
      🚩 Report this listing
    </a>
  </div>
);

export default PoliciesSection;
